import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

// Nötr beyaz sayfa. `gate` true ise (gizli adres /2026) sayfaya 5 kez dokununca
// giriş ekranı açılır; nötr adreste hiçbir tetikleyici yoktur.
export default function Blank({ gate = false }) {
  const navigate = useNavigate();
  const taps = useRef([]);

  const onTap = () => {
    if (!gate) return;
    const now = Date.now();
    taps.current = [...taps.current, now].filter((t) => now - t < 4000);
    if (taps.current.length >= 5) {
      taps.current = [];
      navigate("/giris-2026");
    }
  };

  return (
    <div
      onClick={onTap}
      data-testid={gate ? "secret-gate" : "blank-page"}
      style={{ minHeight: "100vh", width: "100%", background: "#ffffff" }}
    />
  );
}
